var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#848383",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.717 14.169a6.46 6.46 0 0 1-6.452-6.452 6.46 6.46 0 0 1 6.452-6.452 6.46 6.46 0 0 1 6.452 6.452 6.46 6.46 0 0 1-6.452 6.452zm0-14.17C3.462 0 0 3.463 0 7.718s3.462 7.717 7.717 7.717c4.255 0 7.717-3.462 7.717-7.717C15.434 3.462 11.972 0 7.717 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.055 4.755 6.475 9.34 4.38 7.244a.632.632 0 1 0-.894.895l2.541 2.544a.63.63 0 0 0 .895 0l5.027-5.032a.634.634 0 0 0-.894-.896z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRight);
export default __webpack_public_path__ + "static/media/right.c448ff9ab94f571c65889487faa4aea0.svg";
export { ForwardRef as ReactComponent };